"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _reactRedux = require("react-redux");

var _lodash = require("lodash");

function useModelState(model) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _lodash.identity;
  return (0, _reactRedux.useSelector)(function (state) {
    return selector(model.__entityModel ? (0, _lodash.get)(state, "entities.".concat(model.modelName)) : model.__valueListModel ? (0, _lodash.get)(state, "valueLists.".concat(model.modelName)) : (0, _lodash.get)(state, model.modelName));
  });
}

var _default = useModelState;
exports.default = _default;